<template>
  <v-card :color="$vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-2'">
    <v-row class="no-gutters">
      <v-col cols="12">
      <v-text-field v-model="search" @input="debounceSearch" prepend-icon="mdi-magnify" label="Search here ..."
          single-line solo hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" sm="12">
        <v-card class="rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#172233' : '#E8F1F8'">
          <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#1A2A3E ' : '#F1F7FB'">
            <v-data-table :headers="headers" :items="copyTradeLists" :server-items-length="pagination?.total || 10"
              :options.sync="options" :loading="isLoading" :items-per-page="options.itemsPerPage" :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
                'items-per-page-text': 'Rows per page:'
              }" @update:options="handleOptionsChange" disable-sort>
              <template v-slot:loading>
                <div class="d-flex align-center justify-center pa-4">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <span class="ml-2">Loading data...</span>
                </div>
              </template>
              <template v-slot:no-data>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-information</v-icon>
                  <span class="ml-2">No data found</span>
                </div>
              </template>
              <template v-slot:no-results>
                <div class="d-flex align-center justify-center pa-4">
                  <v-icon color="secondary">mdi-magnify</v-icon>
                  <span class="ml-2">No matching data found</span>
                </div>
              </template>
              <template v-slot:item.sl="{ item, index }">
                {{ index + 1 }}
              </template>
              <template v-slot:item.name="{ item }">
                <router-link class="text-capitalize text--ash"
                  :to="`/registered-user-details/${item.client_account_id}`">
                  {{ `${item.name} (${item.client_account_id})` }}
                </router-link>
              </template>
              <template v-slot:item.status="{ item }">
                <div class="status-selection">
                  <v-switch :disabled="$canRoute('managers') !== 1" :input-value="Boolean(item.status)" @change="handleStatus(item)" inset color="#039de9"
                    :ripple="false">
                    <template v-slot:label>
                      <span class="account-status">{{ item.status == 1 ? 'Active' : 'Inactive' }}</span>
                    </template>
                  </v-switch>
                </div>
              </template>
              <template v-slot:item.details="{ item }">
                <router-link class="links text-decoration-none mr-5"
                  :to="`/manager-statistics?account=${item.trading_acc}`">
                  <v-icon color="#039de9" small>
                    mdi-signal
                  </v-icon>
                </router-link>
                <router-link class="links text-decoration-none"
                  :to="`/manager-details?id=${item.id}&account=${item.trading_acc}`">
                  <v-icon color="#039de9" small>
                    mdi-eye-outline
                  </v-icon>
                </router-link>
              </template>
            </v-data-table>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>


<script>
import { MAM__ACTIONS } from "@/store/action-types";
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      search: "",
      searchTimeout: null,
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      headers: [
        { text: "Sl", align: "center", value: "sl" },
        { text: "Account Name", value: "name" },
        { text: "Manager Username", value: "username" },
        { text: "Acc. No.", value: "account_no" },
        { text: "Manager Type", value: "manager_type" },
        { text: "Age (in days)", value: "age" },
        { text: "Investors", value: "investors" },
        { text: "Status", value: "status" },
      ],
    };
  },

  computed: {
    ...mapState("mam", ["copyTradeLists","pagination", "isLoading"]),
    ...mapState("markettingtools", ["bannerSizes", "bannerCategories"]),
    ...mapState("admins", ["loggedAdmin"]),
  },

  methods: {
    ...mapActions("mam", [
      MAM__ACTIONS.GETALLCOPYTRADE,
      MAM__ACTIONS.CHANGEMANAGERSTATUS
    ]),

    async fetchData() {
      const parameter = {
        page: this.options.page || 1,
        limit: this.options.itemsPerPage || 10,
        search: this.search,
      };
      await this[MAM__ACTIONS.GETALLCOPYTRADE](parameter);
    },

    async handleSearch(value) {
      await this.fetchData();
    },

    debounceSearch() {
      if (this.searchTimeout) clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.handleSearch();
      }, 500);
    },

    handleOptionsChange(options) {
      this.fetchData();
    },

    handleStatus(item) {
      const newStatus = !item.status ? 1 : 0;
      try {
        this[MAM__ACTIONS.CHANGEMANAGERSTATUS]({
          status: newStatus,
          id: item.st_manager_id,
        });
      } catch (error) {
        console.error("Error changing status:", error);
      }
    },
  },

  async created() {
    await this.fetchData();
     if (this.$canRoute('managers') === 1) {
      this.headers.push({ text: "Action", value: "details" });
    }
  },
};
</script>
